export default __webpack_public_path__ + "static/media/single_tick.c8e4105e.svg";